import React from "react";

import EmergencyResponseProcedureSection from "../../../../../../../SwmsMasters/EmergencyPlans/sections/section-types/EmergencyResponseProcedureSection";

export default function JobSwmsV3EmergencyResponseProcedureSection({ loading }) {
  return <EmergencyResponseProcedureSection loading={loading} />;
}
